import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { DataTable, DataTableRowClickEvent } from "primereact/datatable";
import { Column } from "primereact/column";
import { useRepresentatives } from "../../api/queries/representatives/useRepresentatives";
import { Representative } from "../../api/types/representative";
import { Button } from "primereact/button";
import {
  formatDateTime,
  parseQueryString,
  toQueryString,
} from "../../common/utils";

export default function RepresentativeList() {
  const navigate = useNavigate();
  const queryParams = parseQueryString(useLocation().search);
  const limit = 20;
  const [offset, setOffset] = useState(0);
  const [total, setTotal] = useState(0);
  const [sortField, setSortField] = useState(queryParams.sortField);
  const [sortOrder, setSortOrder] = useState(queryParams.sortOrder);
  const onPage = (event: any) => setOffset(event.first);
  const onSort = (event: any) => {
    setSortField(event.sortField);
    setSortOrder(event.sortOrder);
  };

  const { data: representatives, isLoading } = useRepresentatives({
    limit,
    offset,
  });

  const onRowClick = (event: DataTableRowClickEvent) =>
    navigate(`/representatives/${event.data.id}`);

  const tFirstName = (row: Representative) => row.first_name;

  const tLastName = (row: Representative) => row.last_name;

  const tCreatedAt = (row: Representative) => formatDateTime(row.created_at);

  const tIsApproved = (row: Representative) => (
    <i className={row.is_approved ? "fa fa-check" : "fa fa-times"} />
  );

  useEffect(() => {
    const queryParamsStr = toQueryString({
      limit,
      offset,
      sortField,
      sortOrder,
    });

    navigate({ search: queryParamsStr });
  }, [offset, navigate, sortField, sortOrder]);

  useEffect(() => {
    if (representatives) {
      setTotal(representatives.data.total_count);
    }
  }, [representatives]);

  return (
    <div className={"col-12"}>
      <div className="flex py-3">
        <h1 className="m-0">Representative</h1>

        <Button
          onClick={() => navigate("/representatives/new")}
          className="p-button p-button-main p-button-sm ml-auto"
          label="Add new"
        />
      </div>

      <DataTable
        emptyMessage={"No records"}
        paginator={true}
        lazy={true}
        rows={limit}
        first={offset}
        totalRecords={total}
        loading={isLoading}
        sortField={sortField}
        sortOrder={sortOrder}
        onPage={onPage}
        onSort={onSort}
        className="p-datatable-sm p-datatable-pointer"
        onRowClick={onRowClick}
        stripedRows={true}
        value={representatives?.data.results || []}
      >
        <Column header={"First name"} body={tFirstName} />

        <Column header={"Last name"} body={tLastName} />

        <Column header={"Approved"} body={tIsApproved} />

        <Column header={"Created at"} body={tCreatedAt} />
      </DataTable>
    </div>
  );
}
